import { supabase } from '../supabaseClient';
import api from './api';

const login = async (email, password) => {
    const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password,
    });
    if (error) throw error;
    return data;
};

const register = async (email, password, options = {}) => {
    const { data, error } = await supabase.auth.signUp({
        email,
        password,
        options: {
        data: options.data, // Para enviar dados extras como 'nome', 'sobrenome'
        },
    });
    if (error) throw error;
    return data;
    };

const logout = async () => {
    const { error } = await supabase.auth.signOut();
    if (error) throw error;
};


// Função para buscar o perfil do usuário logado no nosso backend
const getMyProfile = async () => {
    try {
        // Faz a chamada GET para o endpoint '/profile/me' do backend.
        // A URL completa será: http://localhost:3001/api/profile/me
        // O token já será incluído automaticamente pelo interceptor no api.js
        const response = await api.get('/profile/me');
        return response.data;
    } catch (error) {
        console.error("Erro ao buscar o perfil no backend:", error.response?.data?.message || error.message);
        throw error; // Lança o erro para que o componente que chamou possa tratá-lo
    }
};

// Agrupa todas as funções do serviço em um objeto para exportação


const authService = {
    login,
    register,
    logout,
    getMyProfile,
};

export default authService;